module.exports = __webpack_public_path__ + "static/how-to-pay-3-6f63f11ee86ad64913245eb35e2447ad.png";